import { Layout, Space, theme } from 'antd';
import { Footer } from 'antd/es/layout/layout';
import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router';
import { useAppSelector } from '../../app/hooks';
import appStore from '../../assets/app.jpg';
import playStore from '../../assets/play.jpg';
import { selectUser } from '../../auth/states/userSlice';
import '../style/layoutStyle.css';
import HeaderContainer from './HeaderContainer';
import Sidebar from './Sidebar';

const { Content } = Layout;

const LayoutContainer: React.FC = () => {
  const [width, setWidth] = useState(245);
  const [collapsed, setCollapsed] = useState(window.innerWidth < 1200 ? true : false);
  const [isHide, setIsHide] = useState(window.innerWidth < 768 ? true : false);
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const user = useAppSelector(selectUser);

  const isTab = () => {
    return window.innerWidth < 1024;
  };
  const isMobile = () => {
    return window.innerWidth < 768;
  };

  useEffect(() => {
    const handleResize = () => {
      if (isTab()) {
        setCollapsed(true);

        // @HANDLE IS MOBILE
        if (isMobile()) {
          setIsHide(true);
        } else {
          setIsHide(false);
        }
      } else {
        setCollapsed(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const headingStyle = {
    fontWeight: 'bold',
    fontSize: '16px',
    marginBottom: '8px',
  };

  const contactStyle = {
    lineHeight: '1.6',
    fontSize: '16px',
    fontWeight: 600,
  };

  return (
    <Layout hasSider style={{ minHeight: '100vh' }} className='layoutDesign custom-scrollbar'>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        setWidth={setWidth}
        width={width}
      />

      {!collapsed ? (
        <div className='innerDiv' style={{ width: width }}></div>
      ) : (
        <div className='innerCollapsedDiv'></div>
      )}

      <Layout
        className='site-layout layout'
        style={{
          marginLeft: collapsed ? (isHide ? 0 : 76.667) : 0,
        }}
      >
        {user?.user_id ? (
          <HeaderContainer collapsed={collapsed} setCollapsed={setCollapsed} />
        ) : (
          <></>
        )}
        <Content
          style={{
            padding: 20,
            minHeight: '90vh',
            background: colorBgContainer,
          }}
        >
          <Outlet />
        </Content>

        <Footer
          style={{
            width: '100%',

            padding: '0.6rem 0',
          }}
        >
          <div
            style={{
              width: '95%',
              margin: '0 auto',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div>
              <div style={contactStyle}>
                <Space>
                  Support: 09638-336699, 01958-398325, 01958-398308, 01958-398305 (10:00 AM – 06:00
                  PM)
                </Space>
                <div>
                  <span>Email: sup.m360ict@gmail.com</span>
                </div>
              </div>
            </div>
            <div>
              <div style={headingStyle}>Download the Trabill App</div>
              <Space size='middle'>
                <a
                  href='https://play.google.com/store/apps/details?id=com.m360ict.trabillNonIATA'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <img src={playStore} width={110} alt='Get it on Google Play' />
                </a>
                <a
                  href='https://apps.apple.com/us/app/trabill-non-iata/id6746191433'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  <img src={appStore} width={110} alt='Download on the App Store' />
                </a>
              </Space>
            </div>
          </div>
        </Footer>
      </Layout>
    </Layout>
  );
};

export default LayoutContainer;
